(function($){
    if($('#coupon_code').length > 0){
        setInterval(function(){
            $('#coupon_code').attr('placeholder', 'Kod kuponu');
        }, 20)
    }
})(jQuery)